import { Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Params } from '@fortawesome/fontawesome-svg-core';
import { interval, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingService } from 'src/app/tracking/tracking.service';
import { tracking_preview_model } from 'src/app/tracking/tracking-model';

@Component({
  selector: 'kett-search-form-loading',
  templateUrl: './search-form-loading.component.html',
  styleUrls: ['./search-form-loading.component.scss'],
})
export class SearchFormLoadingComponent implements OnInit {
  ListSearch: string[] = [];
  constructor(
    private _ActivatedRoute: ActivatedRoute,
    private _Router: Router,
    private _TrackingService: TrackingService
  ) {}

  private ngDestroyed$ = new Subject<void>();
  ngOnInit(): void {
    this._ActivatedRoute.queryParams
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((queryParams: Params) => {
        this.ListSearch = [];
        if (queryParams && queryParams['track']) {
          let decode = this._TrackingService.DecryptOldTrack(
            queryParams['track']
          );

          this.ListSearch = decode.split(',');

          this._Router.navigate(['result'], {
            queryParams:
              this.ListSearch.length > 0
                ? {
                    track: this.ListSearch.join(','),
                  }
                : {},
          });
        } else {
          this._Router.navigate(['']);
        }
      });
  }

  ngOnDestroy() {
  }
}
